import { isTGender } from '~constants/gender';

import { FILTER_MAX_AGE, FILTER_MIN_AGE } from '../model/config';
import { GridFiltersFormFields as fields } from '../model/names';
import type { TGridFiltersFormValues, TGridFiltersQuery } from '../model/types';
import { isCreatedBy } from '../model/types';

export const parseFilters = (filters: TGridFiltersQuery) => {
	const values = {} as TGridFiltersFormValues;
	const { minAge, maxAge, gender, keyword, createdBy } = filters;

	if (minAge) {
		const parsedAge = parseInt(minAge);
		if (
			Number.isFinite(parsedAge) &&
			parsedAge > FILTER_MIN_AGE &&
			parsedAge < FILTER_MAX_AGE
		) {
			values[fields.fromAge] = parsedAge;
		}
	}
	if (maxAge) {
		const parsedAge = parseInt(maxAge);
		if (
			Number.isFinite(parsedAge) &&
			parsedAge > FILTER_MIN_AGE &&
			parsedAge < FILTER_MAX_AGE
		) {
			values[fields.toAge] = parsedAge;
		}
	}
	if (gender && isTGender(gender)) {
		values[fields.gender] = gender;
	}
	if (keyword) {
		values[fields.keyword] = keyword;
	}
	if (createdBy && isCreatedBy(createdBy)) {
		values[fields.createdBy] = createdBy;
	}

	return values;
};
